module.exports = [
    '$analytics', 
    '$uibModal', 
    btiModal
];

function btiModal(
    $analytics, 
    $uibModal
) {

    var modal = {
        goodsCode: null,
        searchQuery: null,
        show: showModal
    };

    btiModalController.$inject = [
        '$uibModalInstance', 
        'btiDataService', 
        'goodsCode', 
        'searchQuery',
    ];

    function btiModalController(
        $uibModalInstance, 
        btiDataService, 
        goodsCode, 
        searchQuery
    ) {

        var vm = {
            $onInit: attached,
            $onDestroy: detached,
            cancel: cancel,
            changeActiveBti: changeActiveBti,
            service: btiDataService,
        };

        var refresh;
        var opacity = 1;

        return vm;

        function attached() {
            // The following is a hack, introduced in October 2020. The reason for it is that
            // Chrome would not render the BTI images properly but a redraw would fix it.
            refresh = setInterval(function() {
                opacity = (opacity === 1 ? 0.99 : 1);
                document.body.style.opacity = opacity;
            }, 40);
            init();
        }

        function detached() {
            document.body.style.opacity = 1;
            clearInterval(refresh);
        }



        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function changeActiveBti(btiReference) {
            btiDataService.changeActiveBti(btiReference);
        }

        function init() {
            btiDataService.clearActiveBti();
            btiDataService.resetFilter();
            btiDataService.filter.goodsCode = goodsCode;
            btiDataService.filter.searchQuery = searchQuery;
            btiDataService.loadNewBtis();
        }


    }

    function showModal(goodsCode, searchQuery) {
        $analytics.eventTrack('open-modal-bti', { category: 'bti' });
        if (goodsCode)
            modal.goodsCode = goodsCode;
        if (searchQuery)
            modal.searchQuery = searchQuery;

        return $uibModal.open({
            animation: true,
            backdrop: true,
            bindToController: true,
            controller: btiModalController,
            controllerAs: 'ctrlBtiModal',
            keyboard: true,
            modalFade: true,
            resolve: {
                goodsCode: function () {
                    return modal.goodsCode;
                },
                searchQuery: function () {
                    return modal.searchQuery;
                }
            },
            size: 'lg',
            templateUrl: 'bti/modals/bti.html',
            windowClass: 'modal-bti'
        }).result.catch(function (res) {
            if (!(res === 'cancel' || res === 'escape key press' || res === 'backdrop click')) {
                throw res;
            }
        });
    }

    return modal;
}